import BillerMerchantCodeMappingList from './BillerMerchantCodeMappingList';
import BillerMerchantCodeMappingShow from './BillerMerchantCodeMappingShow';
import BillerMerchantCodeMappingCreate from './BillerMerchantCodeMappingCreate';
import BillerMerchantCodeMappingEdit from './BillerMerchantCodeMappingEdit';

const resource = {
  list: BillerMerchantCodeMappingList,
  show: BillerMerchantCodeMappingShow,
  create: BillerMerchantCodeMappingCreate,
  edit: BillerMerchantCodeMappingEdit,
};

export default resource;
